import { apiGet } from '@/features/shared/utils/dataFetching'
import { type ReasonCode } from '@/features/shop/services/ReasonCodes/types'

export const fetchReasonCode = async (event_type: string, description: string) => {
  const channel = 'marketplace'
  const user_entity = 'member-web-app'

  return apiGet<ReasonCode[]>({
    config: {
      url: `reason-codes/v1/external/reasons`,
      params: { channel, event_type, user_entity, description },
    },
    fetcherName: 'fetchReasonCode',
  })
}
